var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quillEditor"},[_c('div',{staticClass:"quill-editor"},[_c('div',{staticClass:"ql-container ql-snow"},[_c('div',{staticClass:"ql-editor",domProps:{"innerHTML":_vm._s(_vm.contents)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }